

































import { Vue, Component, Prop, Ref } from 'vue-property-decorator'
import store from 'src/assets/store'
import ModalDialog from 'components/modals/Dialog.vue'
import api from 'src/assets/api/gql'
import StudentUpdate from 'src/graphql/student/StudentUpdate.gql'
import { Student, StudentGroup } from 'src/graphql/types'

@Component({
  components: {
    ModalDialog
  }
})
export default class ItemCourseStudentButtonGroup extends Vue {
  state = store.state

  @Prop()
  readonly student!: Student

  @Prop()
  readonly groups!: StudentGroup[]

  @Ref()
  readonly dialog!: ModalDialog

  async changeGroup(studentGroupId: number | null) {
    this.dialog.hide()
    if (this.student) {
      const { data: { updateStudent } } = await api.mutate({
        query: StudentUpdate,
        variables: {
          id: this.student.id,
          data: { studentGroupId }
        }
      })
      this.$emit('update', updateStudent.student)
    }
  }
}
